// alterado - revisado

const tipoCondicaoSaudeList = [
    {
        id: 10,
        descricao: 'Saudável',
        ordem: 10,
        informaDadosDoenca: 'N',
        informaDadosCirurgia: 'N',
    },
    {
        id: 20,
        descricao: 'Cirugia',
        ordem: 20,
        informaDadosDoenca: 'N',
        informaDadosCirurgia: 'S',
    },
    {
        id: 30,
        descricao: 'Câncer',
        ordem: 30,
        informaDadosDoenca: 'S',
        informaDadosCirurgia: 'N',
    },
    {
        id: 40,
        descricao: 'Esclerose Múltipla',
        ordem: 40,
        informaDadosDoenca: 'S',
        informaDadosCirurgia: 'N',
    },
    {
        id: 900,
        descricao: 'Outras Doenças',
        ordem: 900,
        informaDadosDoenca: 'S',
        informaDadosCirurgia: 'N',
    },
]

export default tipoCondicaoSaudeList